import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ExternalLink } from "lucide-react";
import { useSeo } from "@/lib/useSeo";
import { getList } from "@/lib/api";
import { IMG } from "@/lib/images";
import { PageHeader } from "@/components/Editorial";

const PLATFORMS = [
  { key: "fnac", label: "Fnac" },
  { key: "cultura", label: "Cultura" },
  { key: "amazon", label: "Amazon" },
  { key: "bookelis", label: "Bookelis" },
];

export default function Boutique() {
  const { data: books = [] } = useQuery({ queryKey: ["books"], queryFn: () => getList("books") });

  useSeo({
    title: "Boutique",
    description: "La boutique de Dorothée Lancelot : retrouvez ses livres et leurs plateformes de vente (Fnac, Cultura, Amazon, Bookelis).",
    path: "/boutique",
  });

  return (
    <div>
      <PageHeader eyebrow="Se procurer les livres" title="Boutique" intro="Retrouvez les livres de Dorothée Lancelot et leurs plateformes de vente." image={IMG.booksShelf} />

      <section className="dl-container py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {books.map((b) => {
            const links = PLATFORMS.filter((p) => b.buy_links?.[p.key]);
            return (
              <div key={b.id} className="dl-card p-6 flex gap-5" data-testid={`shop-${b.slug}`}>
                <Link to={`/livres/${b.slug}`} className="shrink-0 w-24">
                  <div className="aspect-[2/3] bg-[#141A2E] border border-[rgba(198,167,106,0.25)] overflow-hidden flex items-center justify-center">
                    {b.cover_url ? <img src={b.cover_url} alt={b.title} className="w-full h-full object-cover" loading="lazy" /> : <span className="serif text-xs text-[#F3E9D2]/60 text-center px-2">{b.title}</span>}
                  </div>
                </Link>
                <div className="flex-1 min-w-0">
                  {b.genre && <div className="dl-eyebrow" style={{ fontSize: "0.55rem" }}>{b.genre}</div>}
                  <Link to={`/livres/${b.slug}`}><h3 className="serif text-lg text-[#F3E9D2] mt-1 hover:text-[#D4B978]">{b.title}</h3></Link>
                  {b.price && <div className="text-[#D4B978] text-sm mt-1">{b.price}</div>}
                  <div className="mt-3">
                    {b.is_new && <span className="text-[0.55rem] tracking-widest uppercase text-[#D4B978] mr-2">Nouveauté</span>}
                    {links.length > 0 ? (
                      <div className="flex flex-wrap gap-2 mt-2">
                        {links.map((p) => (
                          <a key={p.key} href={b.buy_links[p.key]} target="_blank" rel="noreferrer" className="text-xs border border-[rgba(198,167,106,0.4)] px-3 py-1.5 text-[#F3E9D2]/85 hover:bg-[#C6A76A] hover:text-[#050814] transition-colors inline-flex items-center gap-1">
                            {p.label} <ExternalLink size={10} />
                          </a>
                        ))}
                      </div>
                    ) : (
                      <Link to={`/livres/${b.slug}`} className="text-xs dl-link mt-2 inline-block">Découvrir le livre →</Link>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}
